<template>
  <small class="form-hint">
    <slot />
  </small>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.form-hint {
  display: block;
  padding: 6px 20px;
  background: rgba(black, 0.03);
  border-radius: 10px;
  margin-top: 8px;
}
</style>
